import {css} from 'lit';

export const style = css`

  :host {
    display: inline-block;
  }

  * {
    box-sizing: border-box;
  }

  ::slotted(p) {
    margin-bottom: 0 !important;
  }

  .alert {
    font: var(--sbkFileUploadTypographyTitle);
    max-width: var(--sbkAlertSizingMaxWidth);
    border-radius: var(--sbkFileUploadBorderRadiusDefault);
    display: flex;
    color: var(--sbkFileUploadColorFgcolorDefault);
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    background-color: inherit;
  }

  .alert-icon {
    padding: var(--sbkFileUploadSpacingIconAreaInsetTopBottom) var(--sbkFileUploadSpacingIconAreaInstLeftRight);
  }

  .alert-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--sbkAlertSpacingStatusAreaGapTitleStatusText);
    padding: var(--sbkAlertSpacingStatusAreaInsetTop) var(--sbkAlertSpacingStatusAreaInsetRight) var(--sbkAlertSpacingStatusAreaInsetBottom) var(--sbkAlertSpacingStatusAreaInsetLeft);
  }

  .alert-title {
    font: var(--sbkFileUploadTypographyTitle);
    font-weight: bold;
  }

  .alert-message {
    display: block;
    font: var(--sbkFileUploadTypographyStatus);
  }

  .alert-error {
    border: var(--sbkAlertBorderError);

    .icon-wrapper,
    .icon-background {
      background-color: var(--sbkAlertColorBgColorError);
    }

    .alert-content {
      color: var(--sbkAlertColorFgColorError);
    }
  }

  .alert-info {
    border: var(--sbkAlertBorderInfo);

    .icon-wrapper,
    .icon-background {
      background-color: var(--sbkAlertColorBgColorInfo);
    }

    .alert-content {
      color: var(--sbkAlertColorFgColorInfo);
    }
  }

  .alert-success {
    border: var(--sbkAlertBorderSuccess);

    .icon-wrapper,
    .icon-background {
      background-color: var(--sbkAlertColorBgColorSuccess);
    }

    .alert-content {
      color: var(--sbkAlertColorFgColorSuccess);
    }
  }
`;
